import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import PredpoplachService from "./PredpoplachService";
import type { Predpoplach, PredpoplachOdpoved } from "../generated/models/Predpoplach";
import { useToast } from "../../../components/toast/useToast";

export const usePredpoplachAktivniQuery = (
    deviceToken?: string,
    options?: { enabled?: boolean }
) => {
    return useQuery<Predpoplach | null, Error>({
        queryKey: ['predpoplachAktivni', deviceToken],
        queryFn: () => PredpoplachService.getAktivni(deviceToken),
        enabled: options?.enabled !== false,
        staleTime: 8000,
        refetchOnWindowFocus: true,
        refetchInterval: 10000,
    });
};

export const usePredpoplachOdpovediQuery = (id: number | null, deviceToken?: string) => {
    return useQuery<PredpoplachOdpoved[], Error>({
        queryKey: ['predpoplachOdpovedi', id, deviceToken],
        queryFn: () => PredpoplachService.getOdpovedi(id!, deviceToken),
        enabled: id !== null,
        refetchInterval: 4000,
    });
};

export const useDeaktivujPredpoplachMutation = () => {
    const { showToast } = useToast();
    const queryClient = useQueryClient();

    return useMutation<void, Error, number>({
        mutationFn: (id) => PredpoplachService.deaktivujPredpoplach(id),

        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['predpoplachAktivni'] });
            showToast("Předpoplach byl úspěšně deaktivován.", "success");
        },

        onError: (error) => {
            showToast(error.message || "Nepodařilo se deaktivovat předpoplach.", "error");
        },
    });
};
